import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------

const LANGS = [
  {
    value: 'en-US',
    label: 'English',
  },
  {
    value: 'es-US',
    label: 'Español',
  },
  {
    value: 'fr-CA',
    label: 'Français',
  },
  {
    value: 'de-DE',
    label: 'Deutsch',
  },
  {
    value: 'pt-BR',
    label: 'Português',
  },
  {
    value: 'zh-CN',
    label: '简体中文',
  },
  {
    value: 'zh-TW',
    label: '繁體中文',
  },
  {
    value: 'ja-JP',
    label: '日本語',
  },
];

// ----------------------------------------------------------------------

export default function useLocales() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language ?? localStorage.getItem('i18nextLng');

  const handleChangeLanguage = (newlang) => {
    i18n.changeLanguage(newlang);
  };

  return {
    onChangeLang: handleChangeLanguage,
    currentLang,
    allLang: LANGS,
  };
}
